




































import { PostColor } from 'types'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class BeethovenAttachmentMetadataSlope extends Vue {
  /**
   * How the component should decide to show dark mode: Using browser or with custom isDark prop
   */
  @Prop({ default: 'browser' }) darkThemeType!: 'browser' | 'custom'
  @Prop({ default: 'browser' }) isDark!: false
  @Prop({ default: 'default' }) color!: 'default' | NonNullable<PostColor>

  get isBrowserDecidingDarkMode(): boolean {
    return this.darkThemeType === 'browser'
  }

  get isForcedLight(): boolean {
    return this.darkThemeType === 'custom' && !this.isDark
  }

  get isForcedDark(): boolean {
    return this.darkThemeType === 'custom' && this.isDark
  }

  get lightMainBgColorClass(): string {
    switch (this.color) {
      case 'red':
        return 'bg-scarlet-200'
      case 'orange':
        return 'bg-canary-200'
      case 'green':
        return 'bg-park-200'
      case 'blue':
        return 'bg-oceanic-200'
      case 'purple':
        return 'bg-grape-200'
      case 'default':
      default:
        return 'bg-light-ui-200'
    }
  }
  get darkMainBgColorClass(): string {
    switch (this.color) {
      case 'red':
        return 'bg-scarlet-700'
      case 'orange':
        return 'bg-tangerine-700'
      case 'green':
        return 'bg-park-700'
      case 'blue':
        return 'bg-oceanic-700'
      case 'purple':
        return 'bg-grape-700'
      case 'default':
      default:
        return 'bg-dark-ui-200'
    }
  }
  get darkBrowserMainBgColorClass(): string {
    switch (this.color) {
      case 'red':
        return 'dark:bg-scarlet-700'
      case 'orange':
        return 'dark:bg-tangerine-700'
      case 'green':
        return 'dark:bg-park-700'
      case 'blue':
        return 'dark:bg-oceanic-700'
      case 'purple':
        return 'dark:bg-grape-700'
      case 'default':
      default:
        return 'dark:bg-dark-ui-200'
    }
  }
  get lightSlopeColorClass(): string {
    switch (this.color) {
      case 'red':
        return 'text-scarlet-200'
      case 'orange':
        return 'text-canary-200'
      case 'green':
        return 'text-park-200'
      case 'blue':
        return 'text-oceanic-200'
      case 'purple':
        return 'text-grape-200'
      case 'default':
      default:
        return 'text-light-ui-200'
    }
  }

  get darkSlopeColorClass(): string {
    switch (this.color) {
      case 'red':
        return 'text-scarlet-700'
      case 'orange':
        return 'text-tangerine-700'
      case 'green':
        return 'text-park-700'
      case 'blue':
        return 'text-oceanic-700'
      case 'purple':
        return 'text-grape-700'
      case 'default':
      default:
        return 'text-dark-ui-200'
    }
  }

  get darkBrowserSlopeColorClass(): string {
    switch (this.color) {
      case 'red':
        return 'dark:text-scarlet-700'
      case 'orange':
        return 'dark:text-tangerine-700'
      case 'green':
        return 'dark:text-park-700'
      case 'blue':
        return 'dark:text-oceanic-700'
      case 'purple':
        return 'dark:text-grape-700'
      case 'default':
      default:
        return 'dark:text-dark-ui-200'
    }
  }
}
